import t from "@ext/localization/locale/translate";
import { SearchMarkedText } from "@ext/serach/components/results/SearchMarkedText";
import { SearchResultBadge } from "@ext/serach/components/results/SearchResultBadge";
import type { SearchResultMarkItem } from "@ext/serach/Searcher";

export interface SearchResultDiagramHeaderItemProps {
	title: SearchResultMarkItem[];
}

export const SearchResultDiagramHeaderItem = (props: SearchResultDiagramHeaderItemProps) => {
	const { title } = props;

	return (
		<>
			<div className="px-2.5 py-1.5 leading-none">
				<SearchResultBadge icon="diagrams" text={t("diagram.name")} />
			</div>
			{title.length > 0 && (
				<div className="px-2.5 py-1.5 font-medium leading-5 text-sm text-secondary-fg">
					<SearchMarkedText marks={title} />
				</div>
			)}
		</>
	);
};
